import { RefObject, useEffect, useRef } from "react";

export const useOutsideClick = (reference: RefObject<HTMLElement>, callback: () => void, selector?: string) => {
  const ref = useRef<HTMLDivElement>(null);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent | PointerEvent) => {
      if (reference?.current && (event.target as Node) !== reference?.current && !reference?.current?.contains(event.target as Node)) {
        callbackRef.current();
      }
    };
    // Capture phase so this still fires even if a nested carousel/gesture
    // library (e.g. Swiper) stops propagation of the event during bubbling.
    // pointerdown (not mousedown) is required because Swiper calls
    // preventDefault() on pointerdown for non-focusable targets, which per
    // the Pointer Events spec suppresses the browser's derived mousedown
    // event entirely on mouse/desktop - mousedown then never fires there.
    document.addEventListener("pointerdown", handleClickOutside, true);
    document.addEventListener("touchstart", handleClickOutside, true);
    return () => {
      document.removeEventListener("pointerdown", handleClickOutside, true);
      document.removeEventListener("touchstart", handleClickOutside, true);
    };
  }, [reference]);

  return ref;
};
